import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { RidePlannerFacade } from '@ridango/components';

@Component({
    selector: 'rwidget-additional-information',
    templateUrl: './additional-information.component.html',
    styleUrls: ['./additional-information.component.scss'],
})
export class AdditionalInformationComponent implements OnInit {
    _additionalForm: FormGroup;

    constructor(private ridePlanner: RidePlannerFacade) {}

    ngOnInit() {
        this._additionalForm = new FormGroup({
            additional_information: new FormControl(''),
        });
    }

    change() {
        const value = this._additionalForm.getRawValue();
        this.ridePlanner.setAdditionalInformation(this._additionalForm.value.additional_information);
    }
}
